/** @jsxImportSource @emotion/react */
import { ROUTES } from '@sportninja/common/constants/app'
import colors from '@sportninja/common/constants/appColors'
import { Link } from 'react-router-dom'
import Text from 'src/components/ts-components/Text'
import GameListTeamLogo from '../../GameListTeamLogo'
import {
  teamContainerStyles,
  teamTextContainerStyles,
  captionSmallLabelStyles,
} from '../styles'

import { GameTeam } from '../types'

interface TeamSectionProps {
  team: GameTeam | undefined
  teamSlot?: GameTeam | undefined
  isHome: boolean
  scheduleId?: string | null
}

const TeamSection = ({
  team,
  teamSlot,
  isHome,
  scheduleId,
}: TeamSectionProps) => {
  const to = team?.id
    ? `${ROUTES.TEAM_ROOT}/${team.id}${
        scheduleId ? `?sn_schedule=${scheduleId}` : ''
      }`
    : undefined
  const disableLink = !to || window.location.pathname === to

  const teamName = team
    ? team?.name_full
    : teamSlot
    ? teamSlot?.name_full
    : isHome
    ? 'Home Team'
    : 'Visiting Team'

  const content = (
    <div css={teamContainerStyles(isHome)}>
      <GameListTeamLogo team={team} style={{ width: 60, height: 60 }} />
      <div css={teamTextContainerStyles(isHome)}>
        <Text variant='heading5' weight='semiBold' color={colors.NEUTRAL_0}>
          {teamName}
        </Text>
        <span css={captionSmallLabelStyles}>{isHome ? 'HOME' : 'VISITOR'}</span>
      </div>
    </div>
  )

  if (disableLink) {
    return content
  }

  return (
    <Link
      to={to!}
      onClick={(e) => e.stopPropagation()}
      style={{ textDecoration: 'none', flex: 1, minWidth: 0 }}
    >
      {content}
    </Link>
  )
}

export default TeamSection
